import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { format } from 'date-fns';

import { UnidataTable } from '~/components';
import { t, number } from '~/helpers';
import { formatISO } from '~/helpers/dateTime';
import Form from '~/pages/Operacao/Transferencia/form';
import {
  findOperacaoTransferencia,
  recordFiltering,
} from '~/store/modules/operacaotransferencia/actions';

export default function Transferencia() {
  const redux = useSelector((state) => state.operacaotransferencia);

  const dateTime = useMemo(
    () => ({
      start: format(new Date(), 'dd/MM/yyyy 00:00:00'),
      end: format(new Date(), 'dd/MM/yyyy 23:59:59'),
    }),
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'datahorainicialmovimentacao',
        label: t('s.operacao.transferencia.datahorainicialmovimentacao'),
        formatted: (date) => formatISO({ date }),
        filter: {
          type: 'initialdatetime',
          defaultValue: dateTime.start,
        },
      },
      {
        id: 'datahorafinalmovimentacao',
        label: t('s.operacao.transferencia.datahorafinalmovimentacao'),
        formatted: (date) => formatISO({ date }),
        filter: {
          type: 'finaldatetime',
          defaultValue: dateTime.end,
        },
      },
      {
        id: 'codigonomeposto',
        label: t('s.operacao.transferencia.nomeposto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'idbico',
        label: t('s.operacao.transferencia.idbico'),
        filter: {
          type: 'number',
        },
        align: 'left',
      },
      {
        id: 'nomeproduto',
        label: t('s.operacao.transferencia.nomeproduto'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigonomepostodestino',
        label: t(
          's.operacao.transferencia.nomeabreviadopostodestinomovimentacaotransferencia'
        ),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'codigousuario',
        label: t('s.operacao.transferencia.codigousuario'),
        filter: {
          type: 'text',
        },
        align: 'left',
      },
      {
        id: 'encerrantemovimentacaotransferencia',
        label: t('s.relatorio.vazaonaoautorizadalistagem.encerrante'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
      {
        id: 'volumemovimentacao',
        label: t('s.operacao.transferencia.volumemovimentacao'),
        align: 'right',
        formatted: (value) => number(value, 2),
      },
    ],
    [dateTime]
  );

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findOperacaoTransferencia}
      form={Form}
      delete={false}
      detach="nomeposto"
      keys={['idmovimentacao', 'idposto']}
    />
  );
}
